import { Box, Typography } from "@mui/material";

export default function ApprovalSummary({ blocked }) {
  return (
    <Box>
      <Typography variant="body1">
        Antes de ser publicado, seu app passará por uma análise da equipe do Google. Aqui, você poderá acompanhar o status até a liberação na loja.
      </Typography>
    </Box>
  )
}